import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Config from 'constants/config'
import './modalMessages.css'
import Modal from '@airbus/components-react/components/Modal'
import MessageHistory from './messageHistory'
import IcoClear from 'resources/images/app/ico_clean.png'
import LightDarkContext from 'context/LightDarkModeContext'
import { Typography } from '@airbus/components-react/components'

const styleModal = {
  position: 'absolute',
  transform: 'translate(calc((100% - ' + Config.MODAL_WIDTH + ') / 2), calc((100% - ' + Config.MODAL_HEIGHT + ') / 2))',
  width: Config.MODAL_WIDTH,
  height: Config.MODAL_HEIGHT,
  border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  overflowX: 'clip',
  textWrap: 'balance',
}

const ModalMessages = (props) => {
  const { t } = useTranslation()

  const messages = props.messages
  const isOpened = props.isOpened
  const onCloseModalMessages = props.onCloseModalMessages
  const onClearMessages = props.onClearMessages

  const [isMessagesQueueEmpty, setMessagesQueueEmpty] = useState(true)

  const handleClearAllMessages = () => {
    onClearMessages()
    setMessagesQueueEmpty(true)
  }

  useEffect(() => {
    setMessagesQueueEmpty(messages.length === 0)
  }, [messages])

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Modal
      className='modalMessages'
      open={isOpened}
      onClose={onCloseModalMessages}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <div style={{ ...styleModal, backgroundColor: getBackgroundColor() }}>
        <ul>
          {messages.length > 0 && !isMessagesQueueEmpty ? (
            <li className='clearAllMessages'>
              <img src={IcoClear} title={t('9500134')} alt={t('9500134')} onClick={handleClearAllMessages} />
            </li>
          ) : (
            <li>
              <Typography>{t('modal_messages_no_message')}</Typography>
            </li>
          )}
          {!isMessagesQueueEmpty &&
            messages.length > 0 &&
            messages.map((msg, i) => (
              <li key={'message_' + i}>
                <MessageHistory message={msg} />
              </li>
            ))}
        </ul>
      </div>
    </Modal>
  )
}

export default ModalMessages
